import { List } from "@mui/material"
import { hasRole } from "auth/hasRole"
import { AppContext } from "components/AppContextProvider"
import { QuickLink } from "components/List/QuickLink/QuickLink"

import { allRoles } from "generated/roles"
import { allRoutes } from "generated/routes"
import { useContext } from "react"
import { useTranslation } from "react-i18next"
export const DashboardQuickLinks = ({ route, title }) => {
  const appContext = useContext(AppContext)
  const isUserIssueReports = hasRole(appContext.appUser, allRoles.IssueReports)
  const isAdminIssueReports = hasRole(appContext.appUser, allRoles.IssueReportsAdmin)
  const { t } = useTranslation()

  return (
    <List disablePadding>
      <QuickLink
        route={allRoutes.IssuereportsArchive}
        text={t("global.features.title.issuereports", "Issue reports")}
      />

      {isAdminIssueReports && (
        <>
          <QuickLink route={allRoutes.IssuereportsWorkorders} text={t("global.workorders", "Workorders")} />
          <QuickLink
            route={allRoutes.IssuereportsWorkordersAdd}
            text={t("global.create_workorder", "Create work order")}
          />
          <QuickLink
            route={allRoutes.IssuereportsArchiveCategories}
            text={t("global.categories", "Categories")}
          />
        </>
      )}
    </List>
  )
}
